import { LogoPropsType } from './logoTypes';

export default function ApacheShortLogo({ className }: LogoPropsType) {
  return (
    <svg
      viewBox="0 0 50 99"
      className={`h-[98.2px] w-[49.01px] ${className}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42.2797 0.461187C40.734 1.36895 38.1825 3.94502 35.1157 7.67419L37.9126 12.9735C39.8753 10.1521 41.8871 7.62512 43.8989 5.46613C44.0461 5.29439 44.1442 5.22079 44.1442 5.22079C44.0706 5.29439 43.997 5.39253 43.8989 5.46613C43.2365 6.17762 41.2738 8.50835 38.2806 13.0962C41.1511 12.949 45.5918 12.3602 49.1983 11.7468C50.2777 5.736 48.1433 2.98819 48.1433 2.98819C48.1433 2.98819 45.4445 -1.4034 42.2797 0.461187Z"
        fill="url(#paint0_linear_2220_19684)"
      />
      <path
        d="M32.8325 44.9365C32.4645 45.0101 32.0965 45.0592 31.7285 45.1328C31.9248 45.1083 32.0965 45.0837 32.2928 45.0347C32.4891 45.0101 32.6608 44.9856 32.8325 44.9365Z"
        fill="#BE202E"
      />
      <path
        opacity="0.35"
        d="M32.8325 44.9365C32.4645 45.0101 32.0965 45.0592 31.7285 45.1328C31.9248 45.1083 32.0965 45.0837 32.2928 45.0347C32.4891 45.0101 32.6608 44.9856 32.8325 44.9365Z"
        fill="#BE202E"
      />
      <path
        d="M33.7904 40.3259C33.7658 40.3259 33.7658 40.3259 33.7904 40.3259C33.8394 40.3259 33.913 40.3014 33.9621 40.3014C34.2075 40.2768 34.4283 40.2278 34.6736 40.1787C34.3547 40.2032 34.0848 40.2768 33.7904 40.3259Z"
        fill="#BE202E"
      />
      <path
        opacity="0.35"
        d="M33.7904 40.3259C33.7658 40.3259 33.7658 40.3259 33.7904 40.3259C33.8394 40.3259 33.913 40.3014 33.9621 40.3014C34.2075 40.2768 34.4283 40.2278 34.6736 40.1787C34.3547 40.2032 34.0848 40.2768 33.7904 40.3259Z"
        fill="#BE202E"
      />
      <path
        d="M29.6451 26.6661C30.5038 25.0714 31.3625 23.5012 32.2457 22.0046C33.1535 20.4345 34.0612 18.8888 34.9935 17.4168C35.0426 17.3186 35.0917 17.245 35.1653 17.1469C36.073 15.6994 37.0053 14.3009 37.9376 12.9761L35.1407 7.67676C34.9199 7.94663 34.7237 8.19197 34.5028 8.46185C33.6932 9.46774 32.8591 10.5472 32.0004 11.7003C31.019 13.0006 30.0377 14.3745 29.0072 15.8221C28.0749 17.1714 27.1181 18.5699 26.1613 20.0174C25.3517 21.2441 24.542 22.5198 23.7324 23.8447C23.7079 23.8937 23.6833 23.9428 23.6343 23.9919L27.2898 31.2049C28.0504 29.6838 28.86 28.1627 29.6451 26.6661Z"
        fill="url(#paint1_linear_2220_19684)"
      />
      <path
        d="M13.0105 67.3054C12.5198 68.6302 12.0537 69.9796 11.563 71.378C11.563 71.4026 11.5384 71.4271 11.5384 71.4271C11.4648 71.6234 11.3912 71.8197 11.3422 72.0159C11.0232 72.9482 10.7288 73.7824 10.0664 75.696C11.1459 76.1867 12.0046 77.487 12.8142 78.9345C12.7161 77.4134 12.1027 75.9904 10.9006 74.8864C16.1999 75.1317 20.7632 73.7824 23.143 69.906C23.3639 69.5625 23.5356 69.1945 23.7319 68.802C22.6524 70.1513 21.3275 70.7401 18.8251 70.5929C18.8251 70.5929 18.8251 70.5929 18.8005 70.5929C18.8005 70.5929 18.8005 70.5929 18.8251 70.5929C22.5052 68.9492 24.3697 67.3545 26.0135 64.7293C26.4061 64.116 26.7741 63.429 27.1666 62.6685C23.9281 65.9806 20.199 66.9128 16.2735 66.2014L13.3294 66.5203C13.1822 66.7902 13.1086 67.0355 13.0105 67.3054Z"
        fill="url(#paint2_linear_2220_19684)"
      />
      <path
        d="M14.3862 60.6954C15.0241 59.0517 15.6865 57.3834 16.349 55.6905C16.9868 54.0713 17.6493 52.452 18.3362 50.8328C19.0232 49.2135 19.7101 47.5697 20.4216 45.926C21.1331 44.2577 21.8691 42.5893 22.6297 40.9456C23.3657 39.3018 24.1262 37.6825 24.8868 36.0878C25.1567 35.499 25.4511 34.9347 25.721 34.3459C26.2116 33.34 26.7023 32.3587 27.193 31.3773C27.2175 31.3282 27.2421 31.2792 27.2666 31.2301L23.6356 24.0171C23.5865 24.1152 23.5129 24.2134 23.4638 24.3115C22.6051 25.7099 21.771 27.1329 20.9368 28.5804C20.1027 30.0525 19.2685 31.549 18.4589 33.0456C17.7719 34.3214 17.1095 35.6217 16.4716 36.922C16.349 37.1919 16.2018 37.4372 16.0791 37.7071C15.294 39.3508 14.558 40.921 13.9201 42.4421C13.1841 44.1595 12.5462 45.8033 11.9574 47.3735C11.5894 48.4039 11.2459 49.3853 10.9269 50.3421C10.6816 51.1517 10.4363 51.9613 10.1909 52.771C9.65117 54.6846 9.18502 56.5983 8.79248 58.4874L12.4726 65.7249C12.9633 64.4246 13.4539 63.1243 13.9692 61.7749C14.1164 61.4315 14.239 61.0635 14.3862 60.6954Z"
        fill="url(#paint3_linear_2220_19684)"
      />
      <path
        d="M8.7405 58.7458C8.27436 61.0766 7.95541 63.3828 7.78368 65.6644C7.78368 65.738 7.75914 65.8362 7.75914 65.9098C6.60604 64.0697 3.53929 62.2787 3.56382 62.3033C5.74735 65.4927 7.41567 68.6576 7.68554 71.7489C6.50791 71.9942 4.88866 71.6507 3.04861 70.9638C4.9868 72.7548 6.43431 73.2454 7.02312 73.3681C5.23214 73.4908 3.39209 74.6929 1.50297 76.1159C4.22624 75.0119 6.45884 74.5703 8.02902 74.9138C5.52655 82.0286 2.99954 89.855 0.49707 98.1966C1.25763 97.9757 1.72377 97.4605 1.99365 96.7491C2.43526 95.2525 5.42841 85.3407 10.0899 72.3377C10.2125 71.9697 10.3597 71.6017 10.4824 71.2337C10.5315 71.1355 10.556 71.0128 10.6051 70.9147C11.0958 69.5408 11.611 68.1669 12.1262 66.7439C12.2489 66.425 12.3715 66.106 12.4942 65.7626V65.738L8.83864 58.5005C8.78957 58.5741 8.76504 58.6722 8.7405 58.7458Z"
        fill="url(#paint4_linear_2220_19684)"
      />
      <path
        d="M27.8525 31.8413C27.7544 32.0621 27.6317 32.2829 27.5336 32.4792C27.2146 33.1416 26.8957 33.804 26.5767 34.4665C26.2333 35.2025 25.8653 35.963 25.5218 36.7236C25.35 37.1161 25.1538 37.5087 24.982 37.9012C24.4423 39.0789 23.878 40.3056 23.3137 41.5813C22.6268 43.127 21.9153 44.7462 21.2038 46.4391C20.5168 48.0338 19.8299 49.7021 19.1429 51.4195C18.4805 53.0387 17.8181 54.7316 17.1311 56.4489C16.5178 57.9946 15.9044 59.5893 15.2911 61.2085C15.2666 61.2822 15.242 61.3558 15.193 61.4539C14.5796 63.0731 13.9662 64.7414 13.3284 66.4343C13.3038 66.4834 13.3038 66.5079 13.2793 66.557L16.2234 66.238C16.1743 66.238 16.1007 66.2135 16.0516 66.2135C19.5845 65.7719 24.2705 63.1467 27.3128 59.8837C28.7112 58.3871 29.987 56.6207 31.1646 54.5353C32.0478 52.9896 32.8574 51.2723 33.6425 49.3831C34.3295 47.7394 34.9919 45.9484 35.6053 43.9857C34.7956 44.4027 33.8633 44.7217 32.8329 44.9425C32.6612 44.9916 32.4649 45.0161 32.2932 45.0406C32.1214 45.0652 31.9252 45.1142 31.7289 45.1388C35.0164 43.863 37.1018 41.4341 38.5984 38.441C37.7397 39.0298 36.3167 39.8149 34.6484 40.1829C34.4276 40.232 34.1823 40.281 33.9369 40.3056C33.8879 40.3056 33.8143 40.3301 33.7652 40.3301C34.9183 39.8394 35.8751 39.3242 36.7093 38.6863C36.881 38.5636 37.0528 38.4164 37.2245 38.2692C37.4698 38.0484 37.7152 37.8276 37.9605 37.5823C38.1077 37.4351 38.2549 37.2633 38.4021 37.0916C38.7211 36.699 39.04 36.282 39.3344 35.8158C39.4326 35.6686 39.5062 35.546 39.6043 35.3987C39.7024 35.1779 39.8251 34.9817 39.9232 34.7854C40.3894 33.8531 40.7574 33.0435 41.0518 32.3075C41.199 31.9394 41.3217 31.6205 41.4444 31.3016C41.4934 31.1789 41.5425 31.0562 41.567 30.9336C41.6897 30.5901 41.7878 30.2711 41.8614 30.0013C41.9841 29.5842 42.0332 29.2652 42.0822 29.0444C41.9596 29.1426 41.8369 29.2162 41.6897 29.3143C40.6838 29.9031 38.991 30.4429 37.617 30.7127C37.5925 30.7127 37.568 30.7127 37.5434 30.7127C37.3962 30.7373 37.2736 30.7618 37.1264 30.7863C37.1509 30.7863 37.1754 30.7618 37.2 30.7618L27.9261 31.7677C27.877 31.7677 27.8525 31.7922 27.8525 31.8413Z"
        fill="url(#paint5_linear_2220_19684)"
      />
      <path
        d="M38.2783 13.0723C37.4441 14.348 36.5609 15.771 35.5795 17.4148C35.5305 17.4884 35.4814 17.5865 35.4323 17.6847C34.5982 19.0831 33.715 20.6533 32.7827 22.3461C31.973 23.8182 31.1389 25.3884 30.2557 27.0812C29.4951 28.5533 28.71 30.1234 27.9004 31.7672L37.1742 30.7613C39.873 29.5101 41.0752 28.3815 42.2528 26.7623C42.5717 26.3207 42.8661 25.8545 43.1851 25.3638C44.1419 23.8673 45.0742 22.248 45.9084 20.6042C46.718 19.034 47.4295 17.4639 47.9692 16.0654C48.3127 15.1822 48.5826 14.348 48.7788 13.612C48.9506 12.9741 49.0732 12.3608 49.1714 11.772C45.5894 12.3363 41.1733 12.9251 38.2783 13.0723Z"
        fill="url(#paint6_linear_2220_19684)"
      />
      <path
        d="M32.2928 45.0576C32.0965 45.0822 31.9248 45.1312 31.7285 45.1558C31.9248 45.1067 32.0965 45.0822 32.2928 45.0576Z"
        fill="#BE202E"
      />
      <path
        opacity="0.35"
        d="M32.2928 45.0576C32.0965 45.0822 31.9248 45.1312 31.7285 45.1558C31.9248 45.1067 32.0965 45.0822 32.2928 45.0576Z"
        fill="#BE202E"
      />
      <path
        d="M32.2928 45.0576C32.0965 45.0822 31.9248 45.1312 31.7285 45.1558C31.9248 45.1067 32.0965 45.0822 32.2928 45.0576Z"
        fill="url(#paint7_linear_2220_19684)"
      />
      <path
        d="M33.7622 40.3248C33.8112 40.3248 33.8847 40.3003 33.9337 40.3003C33.8847 40.3003 33.8357 40.3003 33.7622 40.3248Z"
        fill="#BE202E"
      />
      <path
        opacity="0.35"
        d="M33.7622 40.3248C33.8112 40.3248 33.8847 40.3003 33.9337 40.3003C33.8847 40.3003 33.8357 40.3003 33.7622 40.3248Z"
        fill="#BE202E"
      />
      <path
        d="M33.7622 40.3248C33.8112 40.3248 33.8847 40.3003 33.9337 40.3003C33.8847 40.3003 33.8357 40.3003 33.7622 40.3248Z"
        fill="url(#paint8_linear_2220_19684)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2220_19684"
          x1="37.494"
          y1="8.3212"
          x2="58.0546"
          y2="2.60479"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F69923" />
          <stop offset="0.3123" stopColor="#F79A23" />
          <stop offset="0.8383" stopColor="#E97826" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2220_19684"
          x1="-7.51108"
          y1="100.603"
          x2="34.308"
          y2="10.9185"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.3233" stopColor="#9E2064" />
          <stop offset="0.6302" stopColor="#C92037" />
          <stop offset="0.7514" stopColor="#CD2335" />
          <stop offset="1" stopColor="#E97826" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2220_19684"
          x1="6.53318"
          y1="93.9582"
          x2="31.4533"
          y2="40.5151"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#282662" />
          <stop offset="0.0954839" stopColor="#662E8D" />
          <stop offset="0.7882" stopColor="#9F2064" />
          <stop offset="0.9487" stopColor="#CD2032" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2220_19684"
          x1="-5.99941"
          y1="95.1754"
          x2="35.8197"
          y2="5.49099"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.3233" stopColor="#9E2064" />
          <stop offset="0.6302" stopColor="#C92037" />
          <stop offset="0.7514" stopColor="#CD2335" />
          <stop offset="1" stopColor="#E97826" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2220_19684"
          x1="-1.73606"
          y1="89.1904"
          x2="20.2411"
          y2="42.0585"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#282662" />
          <stop offset="0.0954839" stopColor="#662E8D" />
          <stop offset="0.7882" stopColor="#9F2064" />
          <stop offset="0.9487" stopColor="#CD2032" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_2220_19684"
          x1="3.28345"
          y1="99.5032"
          x2="45.1026"
          y2="9.81873"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.3233" stopColor="#9E2064" />
          <stop offset="0.6302" stopColor="#C92037" />
          <stop offset="0.7514" stopColor="#CD2335" />
          <stop offset="1" stopColor="#E97826" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_2220_19684"
          x1="0.229489"
          y1="104.852"
          x2="42.0486"
          y2="15.1679"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.3233" stopColor="#9E2064" />
          <stop offset="0.6302" stopColor="#C92037" />
          <stop offset="0.7514" stopColor="#CD2335" />
          <stop offset="1" stopColor="#E97826" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_2220_19684"
          x1="6.0435"
          y1="100.784"
          x2="47.8643"
          y2="11.0983"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.3233" stopColor="#9E2064" />
          <stop offset="0.6302" stopColor="#C92037" />
          <stop offset="0.7514" stopColor="#CD2335" />
          <stop offset="1" stopColor="#E97826" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_2220_19684"
          x1="5.7607"
          y1="100.554"
          x2="47.5198"
          y2="10.9908"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.3233" stopColor="#9E2064" />
          <stop offset="0.6302" stopColor="#C92037" />
          <stop offset="0.7514" stopColor="#CD2335" />
          <stop offset="1" stopColor="#E97826" />
        </linearGradient>
      </defs>
    </svg>
  );
}
